import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';

export const publicNewUrl = `${SERVER_API}/public/news`;

export const PUBLIC_NEWS = {
  LIST: {
    method: 'GET',
    url: `${SERVER_API}/public/news`,
  },
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/public/news/${id.toString()}`,
    };
  },
};
